module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jcr-759aa6fb1dfa048be32f10d5260231df.svg";